import React, { useState } from 'react';
import { Check, ChevronRight, Download, FileText, Mail, FileCheck } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Checkbox } from '../../components/ui/checkbox';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

export const ClientReportBuilder = () => {
    const [step, setStep] = useState(1);
    const [sections, setSections] = useState({
        executive: true,
        portfolio: true,
        monitoring: false,
        procedures: false,
        bp: false
    });

    const handleGenerate = () => {
        toast.info("Generando PDF... Esto tardará unos segundos.", {
            description: "Modo Mock: Simulación de generación completada."
        });
        setTimeout(() => {
            toast.success("Reporte generado exitosamente", {
                action: {
                    label: "Descargar",
                    onClick: () => console.log("Download")
                }
            });
        }, 1500);
    };

    return (
        <div className="max-w-4xl mx-auto space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
            {/* Stepper */}
            <div className="flex items-center justify-center gap-4 text-sm font-medium text-gray-500">
                <div className={`flex items-center gap-2 ${step >= 1 ? 'text-indigo-600' : ''}`}>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${step >= 1 ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'}`}>1</div>
                    Configuración
                </div>
                <div className="w-12 h-px bg-gray-200" />
                <div className={`flex items-center gap-2 ${step >= 2 ? 'text-indigo-600' : ''}`}>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${step >= 2 ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'}`}>2</div>
                    Contenido
                </div>
                <div className="w-12 h-px bg-gray-200" />
                <div className={`flex items-center gap-2 ${step >= 3 ? 'text-indigo-600' : ''}`}>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${step >= 3 ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'}`}>3</div>
                    Preview & Export
                </div>
            </div>

            {/* Content Content - Simplified Wizard */}
            <Card className="min-h-[400px]">
                <CardContent className="p-8">
                    {step === 1 && (
                        <div className="space-y-6 max-w-md mx-auto text-center">
                            <h2 className="text-xl font-bold mb-4">Configura tu Reporte</h2>
                            <p className="text-gray-500 mb-6">Elige el cliente y el periodo desde la barra superior de filtros.</p>
                            <Button onClick={() => setStep(2)} className="w-full">
                                Continuar <ChevronRight className="ml-2 h-4 w-4" />
                            </Button>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="max-w-lg mx-auto">
                            <h2 className="text-xl font-bold mb-6 text-center">Selecciona las Secciones</h2>
                            <div className="space-y-4">
                                {Object.keys(sections).map(key => (
                                    <div key={key} className="flex items-center space-x-3 p-4 border rounded-lg hover:bg-gray-50 cursor-pointer" onClick={() => setSections(p => ({ ...p, [key]: !p[key] }))}>
                                        <Checkbox checked={sections[key]} />
                                        <div className="flex-1">
                                            <Label className="uppercase font-bold text-sm cursor-pointer">{key}</Label>
                                            <p className="text-xs text-gray-500">Incluye tablas detalladas y gráficos de resumen.</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="flex gap-4 mt-8">
                                <Button variant="outline" onClick={() => setStep(1)} className="flex-1">Atrás</Button>
                                <Button onClick={() => setStep(3)} className="flex-1">Generar Preview</Button>
                            </div>
                        </div>
                    )}

                    {step === 3 && (
                        <div className="flex flex-col md:flex-row gap-8">
                            <div className="flex-1 space-y-4">
                                <h3 className="font-bold text-lg">Resumen del Reporte</h3>
                                <div className="p-4 bg-gray-50 rounded text-sm space-y-2">
                                    <p><strong>Cliente:</strong> (Según Filtro)</p>
                                    <p><strong>Formato:</strong> PDF Alta Resolución</p>
                                    <p><strong>Secciones:</strong> {Object.entries(sections).filter(([k, v]) => v).length}</p>
                                </div>
                                <div className="space-y-2">
                                    <Button className="w-full" onClick={handleGenerate}>
                                        <Download className="mr-2 h-4 w-4" /> Descargar PDF Final
                                    </Button>
                                    <Button variant="outline" className="w-full" onClick={() => toast.success("Enviado por correo")}>
                                        <Mail className="mr-2 h-4 w-4" /> Enviar por Email
                                    </Button>
                                </div>
                            </div>

                            {/* Visual Preview Placeholder */}
                            <div className="flex-[2] border-2 border-dashed border-gray-200 rounded-lg flex items-center justify-center bg-gray-50 min-h-[300px]">
                                <div className="text-center text-gray-400">
                                    <FileCheck className="h-16 w-16 mx-auto mb-4 opacity-50" />
                                    <p>Vista Previa del Documento</p>
                                </div>
                            </div>
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};
